import React, { useState, useEffect, useCallback } from 'react';

const API = process.env.REACT_APP_API_URL || '/api';
async function req(path, opts = {}) {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API}${path}`, {
    ...opts,
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}), ...opts.headers },
    body: opts.body ? JSON.stringify(opts.body) : undefined,
  });
  return res.json();
}

const STATUS = {
  pendente: { label: 'Pendente', color: '#c9a227', bg: 'rgba(201,162,39,0.15)' },
  parcial: { label: 'Parcial', color: '#4a9af5', bg: 'rgba(74,154,245,0.15)' },
  pago: { label: 'Pago', color: '#34d399', bg: 'rgba(37,211,102,0.2)' },
  atrasado: { label: 'Atrasado', color: '#fca5a5', bg: 'rgba(239,68,68,0.15)' },
};

export default function PagamentosPendentes() {
  const [pags, setPags] = useState([]);
  const [totais, setTotais] = useState({});
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');
  const [search, setSearch] = useState('');
  const [sel, setSel] = useState(null);
  const [showNew, setShowNew] = useState(false);
  const [form, setForm] = useState({ cliente_nome: '', cliente_telefone: '', descricao: '', valor_total: '', vencimento: '', observacao: '', tipo: 'pendencia' });
  const [parcForm, setParcForm] = useState({ valor: '', data: new Date().toISOString().slice(0, 10), metodo: 'pix', observacao: '' });
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    const params = new URLSearchParams();
    if (filter) params.set('status', filter);
    if (search) params.set('search', search);
    const data = await req('/admin/store/pagamentos?' + params);
    setPags(data.pagamentos || []);
    setTotais(data.totais || {});
    setLoading(false);
  }, [filter, search]);

  useEffect(() => { load(); }, [load]);

  const criar = async () => {
    if (!form.cliente_nome || !form.valor_total) return;
    setSaving(true);
    await req('/admin/store/pagamentos', { method: 'POST', body: form });
    setShowNew(false);
    setForm({ cliente_nome: '', cliente_telefone: '', descricao: '', valor_total: '', vencimento: '', observacao: '', tipo: 'pendencia' });
    load();
    setSaving(false);
  };

  const addParcial = async () => {
    if (!parcForm.valor || !sel) return;
    setSaving(true);
    const updated = await req('/admin/store/pagamentos/' + sel.id + '/parcial', { method: 'POST', body: parcForm });
    setSel(updated);
    setParcForm({ valor: '', data: new Date().toISOString().slice(0, 10), metodo: 'pix', observacao: '' });
    load();
    setSaving(false);
  };

  const deletePag = async (id) => {
    if (!window.confirm('Remover este registro?')) return;
    await req('/admin/store/pagamentos/' + id, { method: 'DELETE' });
    setSel(null);
    load();
  };

  // Detail view
  if (sel) {
    const s = STATUS[sel.status] || STATUS.pendente;
    const restante = parseFloat(sel.valor_total) - parseFloat(sel.valor_pago);
    const parciais = Array.isArray(sel.parciais) ? sel.parciais : (typeof sel.parciais === 'string' ? JSON.parse(sel.parciais) : []);
    const waMsg = encodeURIComponent(`Olá ${sel.cliente_nome}! Passando pra lembrar do pagamento pendente de R$ ${restante.toFixed(2)} referente a: ${sel.descricao || 'compra na Brahim Cards'}. Pode me chamar pra combinar!`);

    return (
      <div style={{ padding: '1.5rem', maxWidth: 650 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
          <button onClick={() => setSel(null)} style={B.back}>← Voltar</button>
          <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: 'var(--text-hi)', flex: 1 }}>{sel.tipo === 'credito' && <span style={{ padding: '2px 10px', borderRadius: 10, fontSize: '0.65rem', fontWeight: 700, background: 'rgba(52,211,153,0.12)', color: '#34d399', marginRight: 8, verticalAlign: 'middle' }}>CRÉDITO</span>}{sel.cliente_nome}</h2>
          <span style={{ padding: '3px 10px', borderRadius: 10, fontSize: '0.68rem', fontWeight: 700, background: s.bg, color: s.color }}>{s.label}</span>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12, marginBottom: 20 }}>
          <Card label="Total" value={`R$ ${parseFloat(sel.valor_total).toFixed(2)}`} color="var(--text-hi)" />
          <Card label="Pago" value={`R$ ${parseFloat(sel.valor_pago).toFixed(2)}`} color="#34d399" />
          <Card label={sel.tipo === 'credito' ? 'Saldo Disponível' : 'Restante'} value={`R$ ${restante.toFixed(2)}`} color={restante > 0 ? '#fca5a5' : '#34d399'} />
        </div>

        {sel.descricao && <Info l="Descrição" v={sel.descricao} />}
        {sel.cliente_telefone && <Info l="Telefone" v={sel.cliente_telefone} />}
        {sel.vencimento && <Info l="Vencimento" v={new Date(sel.vencimento).toLocaleDateString('pt-BR')} />}
        {sel.observacao && <Info l="Observação" v={sel.observacao} />}

        {/* Histórico de pagamentos */}
        <h3 style={B.sec}>Pagamentos Registrados</h3>
        {parciais.length === 0 ? <p style={{ color: 'var(--text-lo)', fontSize: '0.82rem' }}>Nenhum pagamento registrado</p> :
          <div style={{ border: '1px solid var(--border)', borderRadius: 8, overflow: 'hidden', marginBottom: 16 }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead><tr style={{ background: 'var(--surface)' }}>
                {['Data', 'Valor', 'Método', 'Obs'].map(h => <th key={h} style={{ padding: '6px 10px', textAlign: 'left', fontSize: '0.7rem', fontWeight: 600, color: 'var(--text-mid)', textTransform: 'uppercase' }}>{h}</th>)}
              </tr></thead>
              <tbody>{parciais.map((p, i) => (
                <tr key={i} style={{ borderTop: '1px solid var(--border)' }}>
                  <td style={B.td}>{new Date(p.data).toLocaleDateString('pt-BR')}</td>
                  <td style={{ ...B.td, color: '#34d399', fontWeight: 600 }}>R$ {parseFloat(p.valor).toFixed(2)}</td>
                  <td style={B.td}>{p.metodo || '—'}</td>
                  <td style={B.td}>{p.observacao || '—'}</td>
                </tr>
              ))}</tbody>
            </table>
          </div>
        }

        {/* Registrar pagamento */}
        {sel.status !== 'pago' && <>
          <h3 style={B.sec}>Registrar Pagamento</h3>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 12 }}>
            <input type="number" step="0.01" placeholder="Valor (R$)" value={parcForm.valor} onChange={e => setParcForm(p => ({ ...p, valor: e.target.value }))} style={{ ...B.input, width: 120 }} />
            <input type="date" value={parcForm.data} onChange={e => setParcForm(p => ({ ...p, data: e.target.value }))} style={{ ...B.input, width: 150 }} />
            <select value={parcForm.metodo} onChange={e => setParcForm(p => ({ ...p, metodo: e.target.value }))} style={{ ...B.input, width: 100 }}>
              <option value="pix">Pix</option>
              <option value="dinheiro">Dinheiro</option>
              <option value="cartao">Cartão</option>
            </select>
            <input placeholder="Obs (opcional)" value={parcForm.observacao} onChange={e => setParcForm(p => ({ ...p, observacao: e.target.value }))} style={{ ...B.input, flex: 1 }} />
            <button onClick={addParcial} disabled={saving} style={B.save}>Registrar</button>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={() => { setParcForm(p => ({ ...p, valor: restante.toFixed(2) })); }} style={B.pill}>Preencher valor restante (R$ {restante.toFixed(2)})</button>
          </div>
        </>}

        {/* Actions */}
        <div style={{ display: 'flex', gap: 10, marginTop: 24 }}>
          {sel.cliente_telefone && (
            <a href={`https://wa.me/55${sel.cliente_telefone.replace(/\D/g, '')}?text=${waMsg}`} target="_blank" rel="noopener noreferrer" style={B.whatsapp}>📲 Cobrar via WhatsApp</a>
          )}
          <button onClick={() => deletePag(sel.id)} style={{ ...B.back, color: 'var(--red, #ef4444)' }}>Excluir registro</button>
        </div>
      </div>
    );
  }

  // New form
  if (showNew) {
    return (
      <div style={{ padding: '1.5rem', maxWidth: 500 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
          <button onClick={() => setShowNew(false)} style={B.back}>← Voltar</button>
          <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: 'var(--text-hi)' }}>{form.tipo === 'credito' ? 'Novo Crédito' : 'Nova Pendência'}</h2>
        </div>
        <div style={{ display: 'flex', gap: 6, marginBottom: 16 }}>
          <button onClick={() => setForm(f => ({ ...f, tipo: 'pendencia' }))} style={{ flex: 1, padding: '10px', borderRadius: 8, fontSize: '0.85rem', fontWeight: 700, cursor: 'pointer', border: form.tipo === 'pendencia' ? '2px solid #fca5a5' : '1px solid var(--border)', background: form.tipo === 'pendencia' ? 'rgba(239,68,68,0.1)' : 'var(--surface)', color: form.tipo === 'pendencia' ? '#fca5a5' : 'var(--text-mid)' }}>Pendência (Fiado)</button>
          <button onClick={() => setForm(f => ({ ...f, tipo: 'credito' }))} style={{ flex: 1, padding: '10px', borderRadius: 8, fontSize: '0.85rem', fontWeight: 700, cursor: 'pointer', border: form.tipo === 'credito' ? '2px solid #34d399' : '1px solid var(--border)', background: form.tipo === 'credito' ? 'rgba(37,211,102,0.1)' : 'var(--surface)', color: form.tipo === 'credito' ? '#34d399' : 'var(--text-mid)' }}>Crédito</button>
        </div>
        <div style={B.field}><label style={B.label}>Nome do Cliente *</label><input style={B.input} value={form.cliente_nome} onChange={e => setForm(f => ({ ...f, cliente_nome: e.target.value }))} placeholder="Nome completo" /></div>
        <div style={B.field}><label style={B.label}>Telefone / WhatsApp</label><input style={B.input} value={form.cliente_telefone} onChange={e => setForm(f => ({ ...f, cliente_telefone: e.target.value }))} placeholder="(32) 99999-9999" /></div>
        <div style={B.field}><label style={B.label}>{form.tipo === 'credito' ? 'Motivo do crédito' : 'O que comprou'}</label><textarea style={{ ...B.input, minHeight: 60 }} value={form.descricao} onChange={e => setForm(f => ({ ...f, descricao: e.target.value }))} placeholder={form.tipo === 'credito' ? 'Ex: Pagou adiantado, saldo de troca' : 'Ex: 2x Booster Box Fogo Fantasmagórico + 1x ETB'} /></div>
        <div style={{ display: 'flex', gap: 12 }}>
          <div style={{ ...B.field, flex: 1 }}><label style={B.label}>Valor Total (R$) *</label><input type="number" step="0.01" style={B.input} value={form.valor_total} onChange={e => setForm(f => ({ ...f, valor_total: e.target.value }))} /></div>
          <div style={{ ...B.field, flex: 1 }}><label style={B.label}>Vencimento</label><input type="date" style={B.input} value={form.vencimento} onChange={e => setForm(f => ({ ...f, vencimento: e.target.value }))} /></div>
        </div>
        <div style={B.field}><label style={B.label}>Observação</label><input style={B.input} value={form.observacao} onChange={e => setForm(f => ({ ...f, observacao: e.target.value }))} placeholder="Opcional" /></div>
        <button onClick={criar} disabled={saving} style={B.save}>{saving ? 'Salvando...' : form.tipo === 'credito' ? 'Criar Crédito' : 'Criar Pendência'}</button>
      </div>
    );
  }

  // List view
  return (
    <div style={{ padding: '1.5rem' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h2 style={{ fontSize: '1.3rem', fontWeight: 700, color: 'var(--text-hi)' }}>Pagamentos e Créditos</h2>
        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={() => { setForm(f => ({ ...f, tipo: "pendencia" })); setShowNew(true); }} style={{ ...B.save, background: "#c9a227" }}>+ Pendência</button>
          <button onClick={() => { setForm(f => ({ ...f, tipo: "credito" })); setShowNew(true); }} style={{ ...B.save, background: "#34d399", color: "#000" }}>+ Crédito</button>
        </div>

      </div>

      {/* Totais */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginBottom: 20 }}>
        <Card label="Total em Aberto" value={`R$ ${(totais.total_aberto || 0).toFixed(2)}`} color="#c9a227" />
        <Card label="Pendências Ativas" value={totais.count_pendentes || 0} color="var(--text-hi)" />
        <Card label="Atrasados" value={totais.count_atrasados || 0} color={totais.count_atrasados > 0 ? '#fca5a5' : '#34d399'} />
        <Card label="Créditos Ativos" value={`R$ ${(totais.total_creditos || 0).toFixed ? (totais.total_creditos || 0).toFixed(2) : '0.00'}`} color="#34d399" />
      </div>

      {/* Filters */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
        <input placeholder="Buscar cliente..." value={search} onChange={e => setSearch(e.target.value)} style={{ ...B.input, maxWidth: 250 }} />
        <select value={filter} onChange={e => setFilter(e.target.value)} style={{ ...B.input, width: 140 }}>
          <option value="">Todos</option>
          {Object.entries(STATUS).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
        </select>
      </div>

      {/* List */}
      {loading ? <p style={{ color: 'var(--text-lo)' }}>Carregando...</p> :
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {pags.map(p => {
            const s = STATUS[p.status] || STATUS.pendente;
            const restante = parseFloat(p.valor_total) - parseFloat(p.valor_pago);
            return (
              <div key={p.id} onClick={() => setSel(p)} style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 10, padding: '14px 16px', cursor: 'pointer' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                  <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>{p.tipo === 'credito' && <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: '0.6rem', fontWeight: 700, background: 'rgba(52,211,153,0.12)', color: '#34d399' }}>CRÉDITO</span>}<span style={{ fontWeight: 700, color: 'var(--text-hi)', fontSize: '0.9rem' }}>{p.cliente_nome}</span></span>
                  <span style={{ padding: '3px 10px', borderRadius: 10, fontSize: '0.65rem', fontWeight: 700, background: s.bg, color: s.color }}>{s.label}</span>
                </div>
                {p.descricao && <div style={{ fontSize: '0.78rem', color: 'var(--text-lo)', marginBottom: 4, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{p.descricao}</div>}
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.8rem' }}>
                  <span style={{ color: 'var(--text-mid)' }}>{p.vencimento ? new Date(p.vencimento).toLocaleDateString('pt-BR') : 'Sem vencimento'}</span>
                  <span>
                    <span style={{ color: '#34d399', marginRight: 8 }}>Pago: R$ {parseFloat(p.valor_pago).toFixed(2)}</span>
                    <span style={{ fontWeight: 700, color: p.tipo === 'credito' ? '#34d399' : restante > 0 ? '#fca5a5' : '#34d399' }}>{p.tipo === 'credito' ? 'Saldo' : 'Resta'}: R$ {restante.toFixed(2)}</span>
                  </span>
                </div>
              </div>
            );
          })}
          {pags.length === 0 && <p style={{ color: 'var(--text-lo)', textAlign: 'center', padding: '2rem' }}>Nenhum registro encontrado</p>}
        </div>
      }
    </div>
  );
}

function Card({ label, value, color }) {
  return (
    <div style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 10, padding: '12px 16px' }}>
      <div style={{ fontSize: '0.68rem', fontWeight: 600, color: 'var(--text-lo)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 4 }}>{label}</div>
      <div style={{ fontSize: '1.2rem', fontWeight: 700, color }}>{value}</div>
    </div>
  );
}
function Info({ l, v }) {
  return <div style={{ display: 'flex', gap: 10, marginBottom: 4, fontSize: '0.82rem' }}><span style={{ color: 'var(--text-lo)', minWidth: 90 }}>{l}:</span><span style={{ color: 'var(--text-hi)' }}>{v}</span></div>;
}

const B = {
  sec: { fontSize: '0.78rem', fontWeight: 700, color: 'var(--text-mid)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 10, marginTop: 20, paddingBottom: 6, borderBottom: '1px solid var(--border)' },
  field: { marginBottom: 12 },
  label: { display: 'block', fontSize: '0.78rem', fontWeight: 600, color: 'var(--text-mid)', marginBottom: 4 },
  input: { width: '100%', padding: '8px 12px', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 6, color: 'var(--text-hi)', fontSize: '0.85rem', outline: 'none', fontFamily: 'inherit' },
  save: { padding: '8px 20px', background: 'var(--accent)', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 700, fontSize: '0.82rem', cursor: 'pointer' },
  back: { padding: '6px 14px', background: 'transparent', color: 'var(--text-mid)', border: '1px solid var(--border)', borderRadius: 6, fontSize: '0.78rem', cursor: 'pointer' },
  pill: { padding: '6px 14px', borderRadius: 20, fontSize: '0.72rem', fontWeight: 600, cursor: 'pointer', background: 'var(--surface)', border: '1px solid var(--border)', color: 'var(--text-mid)' },
  td: { padding: '6px 10px', fontSize: '0.8rem', color: 'var(--text-mid)' },
  whatsapp: { display: 'inline-flex', alignItems: 'center', gap: 8, padding: '10px 20px', background: '#25d366', color: '#fff', borderRadius: 8, fontWeight: 700, fontSize: '0.82rem', textDecoration: 'none' },
};
